import { takeEvery, put, select } from 'redux-saga/effects';
import { LocationChangeAction, LOCATION_CHANGE, push } from 'connected-react-router';
import { LOGOUT, LOGIN, actions } from 'shared/actions/app';
import { notMyBusinessAnymore } from 'shared/consts';
import { isAuthenticated as isAuthenticatedSelector } from 'shared/selectors/app';

const root = '/investments';

export default function* () {
  yield takeEvery(LOGOUT, function* () {
    yield put(actions.showAuthModal('signin', 'mainMenu', 'desktopInvestmentRegistration'));
  });

  yield takeEvery(LOGIN, function* (action: ReturnType<typeof actions.login>) {
    if (window.location.pathname === '/') {
      notMyBusinessAnymore.some((regexp) => regexp.test(root))
        ? (window.location.href = root)
        : yield put(push(root));
    }
  });

  yield takeEvery(
    LOCATION_CHANGE,
    function* ({ payload: { isFirstRendering, location } }: LocationChangeAction) {
      const { isAuthenticated }: ReturnType<typeof isAuthenticatedSelector> = yield select(
        isAuthenticatedSelector
      );
      if (!isAuthenticated && isFirstRendering && location.pathname.match(/\/(deposit|withdraw)/)) {
        yield put(actions.showAuthModal('signin', 'mainMenu', 'desktopMainMenuRegistration'));
      }
    }
  );
}
